<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM203/banner.jpg')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">AI 智能安保巡逻机器人 LM203</div>
          <div class="title-2">基于园区级 L4 自动驾驶<br>
            可在复杂环境自主运行、智能巡检与安防</div>
          <div class="title-3" @click="openContactUs">
            申请试用
          </div>
        </div>
      </div>

    </div>

    <!-- 核心能力 -->
    <div class="capability-section" data-aos="fade-up">
      <div class="section-title-small">核心技术</div>
      <div class="section-subtitle">两大核心模块 打造全场景安保智能巡逻机器人</div>
      <div class="capability-grid">
        <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
          <img class="capability-icon" :src="item.icon" alt="">
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <div class="capability-section" data-aos="fade-up">
      <div class="section-title-small">核心卖点</div>
      <div class="section-subtitle">四大核心功能 全方位保障安防巡检无死角</div>
      <div class="capability-grid1">
        <div class="capability-card" v-for="(item, index) in featureList" :key="index">
          <img class="capability-icon" :src="item.icon" alt="">
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>


    <!-- 技术特点 -->
    <div class="feature-section" data-aos="fade-up"
      :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM203/icon7.jpg')})` }">
    </div>


    <div class="flor3" data-aos="fade-up">
      <div class="f2-title">适配应用场景</div>
      <div class="f2-subtitle">聚焦零售商超领域 适配不同规模零售场景</div>

      <div class="scene-cards-container">
        <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
          <div class="f3-card">
            <img class="bgimg" :src="scene.icon" />
            <div class="title">{{ scene.name }}</div>
            <div class="subtitle">{{ scene.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.lm203,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/robot/LM203/icon1.svg"), name: '轻量化 AI 视觉模型', desc: '多场景精准识别，低光环境仍清晰，识别准确率 98.8%。' },
        { icon: require("@/assets/product/robot/LM203/icon2.svg"), name: '测距避障模块', desc: '自主巡逻 + 定点值守，适应复杂地形，避障响应速度 0.2 秒。' },
      ],
      featureList: [
        { icon: require("@/assets/product/robot/LM203/icon3.svg"), name: '自主巡逻 + 定点值守', desc: '灵活适配不同安防需求，支持多路线切换。' },
        { icon: require("@/assets/product/robot/LM203/icon4.svg"), name: '烟火/气体检测', desc: '实时识别危险隐患，10 秒内触发声光 + 远程报警。' },
        { icon: require("@/assets/product/robot/LM203/icon5.svg"), name: '热成像 + 夜间检测', desc: '-20℃~50℃环境正常工作，低光下精准识别人体。' },
        { icon: require("@/assets/product/robot/LM203/icon6.svg"), name: '多维度数据采集', desc: '支持仪表读数、车牌/人脸识别，行为异常分析。' }
      ],
      sceneList: [
        { icon: require("@/assets/product/robot/LM203/icon8.png"), name: '工业园区', desc: '适配园区面积大、设备繁多、安全风险较高的特点，实现智能巡检、设备监测与安防管理一体化，提升园区运行效率与安全保障。' },
        { icon: require("@/assets/product/robot/LM203/icon9.png"), name: '智慧社区', desc: '面向社区场景，兼顾居民日常生活与隐私保护需求，提供智能安防、环境监测、便民服务等功能，打造安全、智能的居住环境。' },
        { icon: require("@/assets/product/robot/LM203/icon10.png"), name: '公共场所', desc: '适配人流量密集、安全要求高的公共场所，实现智能疏导、安防预警、环境管理，提升场所运营秩序与应急处置能力，保障公共安全。' },

      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'LM203')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}


/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-title-small {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-grid1 {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;
  flex: 1;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}


/* 技术特点 */
.feature-section {
  width: 100%;
  padding: 80px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh;
  /* 视窗高度的 80% */
}



.flor3 {
  width: 100%;
  background: #F4F5FB;
  display: flex;
  flex-direction: column;
  padding: 80px 0 80px;

  .f2-title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    margin-bottom: 35px;
  }

  .f2-subtitle {
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  .scene-cards-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .scene-card-item {
    border-radius: 6px;
    overflow: hidden;
  }

  .f3-card {
    background: #ffffff;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .f3-card .bgimg {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  .f3-card .title {
    font-weight: bold;
    font-size: 22px;
    color: #222222;
    line-height: 22px;
    text-align: left;
    padding: 20px;
    margin: 0;
  }

  .f3-card .subtitle {
    font-size: 14px;
    color: #222222;
    line-height: 22px;
    text-align: justify;
    padding: 0 20px 20px 20px;
    margin: 0;
    flex: 1;
  }

}
</style>
